import {getMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/dailyRates', request)
}

async function put(request) {
    return await putMethod('/api/dailyRates', request)
}

export {get, put}
